//document.documentElement.className = document.documentElement.className.replace('no-js', 'supports-js');
if (localStorage.getItem('site_consent_analytics') === 'granted') {
    // ensure the loader from cookieconsent-config runs (function is global)
    if (typeof enableGoogleAnalyticsConsent === 'function') {
      enableGoogleAnalyticsConsent();
    } else {
      // fallback: convert analytics scripts if cookieconsent-config hasn't defined the function yet
      document.addEventListener('DOMContentLoaded', function() {
        if (typeof enableGoogleAnalyticsConsent === 'function') enableGoogleAnalyticsConsent();
      });
    }
  }

document.addEventListener('DOMContentLoaded', function() {
    const description = document.getElementById('collectionDescription');
    const readMoreBtn = document.getElementById('readMoreBtn');

    if (description && readMoreBtn) {
        if (description.scrollHeight > description.clientHeight + 10) {
            readMoreBtn.style.display = 'block';
        } else {
            readMoreBtn.style.display = 'none';
        }

        readMoreBtn.addEventListener('click', function() {
            if (description.classList.contains('expanded')) {
                description.classList.remove('expanded');
                readMoreBtn.textContent = 'mehr lesen ...';
            } else {
                description.classList.add('expanded');
                readMoreBtn.textContent = 'weniger lesen ...';
            }
        });
    }
});

window.addEventListener('load', function() {
    checkContactForms()
    addShippingDate()
    benefitsTextSlider()
})

window.addEventListener('scroll', function() {
    const scroll = window.scrollY;
    const header = document.getElementById('header');
    const mobileHeaderGray = document.getElementById('mobile_header_gray');
    const siteNav = document.getElementById('site_nav');
    const headerLogo = document.getElementById('header_logo');

    if (header) {
        if (scroll >= 50) {
            header.classList.add('xl:shadow-lg');
            if (mobileHeaderGray) mobileHeaderGray.classList.add('hidden');
            if (siteNav) {
                siteNav.classList.remove('2xl:text-lg');
                siteNav.classList.add('2xl:text-sm');
            }
            if (headerLogo) {
                headerLogo.classList.remove('2xl:w-[550px]');
                headerLogo.classList.add('2xl:w-[300px]');
            }
        }
        else {
            header.classList.remove('xl:shadow-lg');
            if (mobileHeaderGray) mobileHeaderGray.classList.remove('hidden');
            if (siteNav) {
                siteNav.classList.remove('2xl:text-sm');
                siteNav.classList.add('2xl:text-lg');
            }
            if (headerLogo) {
                headerLogo.classList.remove('2xl:w-[300px]');
                headerLogo.classList.add('2xl:w-[550px]');
            }
        }
    }
})

function checkContactForms() {
    if (window.location.search.includes("contact_posted=true")) {
        const headerSuccess = document.getElementById('header_success');
        if (headerSuccess) {
            headerSuccess.classList.remove('-top-[200px]');
            headerSuccess.classList.add('top-24', 'lg:top-10');
            setTimeout(() => {
                headerSuccess.classList.remove('top-24', 'lg:top-10');
                headerSuccess.classList.add('-top-[200px]');
            }, 4000);
        }
    }
}

//////////////////////////////
// CART BLOCK
//////////////////////////////
function openCartBlock() {
    document.body.classList.add('overflow-hidden')
    const cartBlock = document.getElementById('cart_block');
    const cartBlockOverlay = document.getElementById('cart_block_overlay');
    if (cartBlock) {
        cartBlock.classList.remove('-right-full', 'lg:-right-[500px]');
        cartBlock.classList.add('right-0');
    }
    if (cartBlockOverlay) {
        cartBlockOverlay.classList.remove('-left-full');
        cartBlockOverlay.classList.add('left-0');
    }
    getCartProducts()
}

function closeCartBlock() {
    document.body.classList.remove('overflow-hidden')
    const cartBlock = document.getElementById('cart_block');
    const cartBlockOverlay = document.getElementById('cart_block_overlay');
    if (cartBlock) {
        cartBlock.classList.remove('right-0');
        cartBlock.classList.add('-right-full', 'lg:-right-[500px]');
    }
    if (cartBlockOverlay) {
        cartBlockOverlay.classList.remove('left-0');
        cartBlockOverlay.classList.add('-left-full');
    }
    closeCartNoteBlock()
    updateCartBadge()
}

function updateCartBadge() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartTotalCount = document.getElementById('cart_total_count');
            if (cart.item_count > 0 && cartTotalCount) {
                cartTotalCount.textContent = cart.item_count;
                cartTotalCount.classList.remove('bg-gray-10');
                cartTotalCount.classList.add('bg-blue-20');
            } else if (cartTotalCount) {
                cartTotalCount.textContent = cart.item_count;
                cartTotalCount.classList.remove('bg-blue-20');
                cartTotalCount.classList.add('bg-gray-10');
            }
        })
        .catch(error => console.error('Error fetching cart:', error));
}


//////////////////////////////
// WISHLIST BLOCK
//////////////////////////////
function openWishlist() {
    document.body.classList.add('overflow-hidden')
    const wishlistBlock = document.getElementById('wishlist_block');
    const wishlistOverlay = document.getElementById('wishlist_overlay');
    if (wishlistBlock) {
        wishlistBlock.classList.remove('-right-full', 'lg:-right-[500px]');
        wishlistBlock.classList.add('right-0');
    }
    if (wishlistOverlay) {
        wishlistOverlay.classList.remove('-left-full');
        wishlistOverlay.classList.add('left-0');
    }
}

function closeWishlist() {
    const wishlistBlock = document.getElementById('wishlist_block');
    const wishlistOverlay = document.getElementById('wishlist_overlay');
    if (wishlistBlock) {
        wishlistBlock.classList.remove('right-0');
        wishlistBlock.classList.add('-right-full', 'lg:-right-[500px]');
    }
    if (wishlistOverlay) {
        wishlistOverlay.classList.remove('left-0');
        wishlistOverlay.classList.add('-left-full');
    }
    document.body.classList.remove("overflow-hidden", "offset-scroll");
}

//////////////////////////////
// RUCKRUF BLOCK
//////////////////////////////

function openRuckrufBlock(product_url, product_title, triggered) {
    const ruckrufSearchContainer = document.getElementById('ruckruf_search_container');
    const ruckrufProductTitle = document.getElementById('ruckruf_product_title');
    const contactFormProductInput = document.getElementById('ContactFormProduct');
    const ruckrufBlock = document.getElementById('ruckruf_block');
    const ruckrufBlockOverlay = document.getElementById('ruckruf_block_overlay');

    if (triggered === 'product') {
        if (ruckrufSearchContainer) ruckrufSearchContainer.classList.add('hidden');
        if (ruckrufProductTitle) ruckrufProductTitle.classList.remove('hidden');
    }
    else {
        if (ruckrufSearchContainer) ruckrufSearchContainer.classList.remove('hidden');
    }

    document.body.classList.add('overflow-hidden')
    if (ruckrufBlock) {
        ruckrufBlock.classList.remove('-right-full', 'lg:-right-[500px]');
        ruckrufBlock.classList.add('right-0');
    }
    if (ruckrufBlockOverlay) {
        ruckrufBlockOverlay.classList.remove('-left-full');
        ruckrufBlockOverlay.classList.add('left-0');
    }
    if (contactFormProductInput) contactFormProductInput.value = product_url;
    if (ruckrufProductTitle) ruckrufProductTitle.textContent = product_title;
}

function closeRuckrufBlock() {
    const ruckrufProductTitle = document.getElementById('ruckruf_product_title');
    const contactFormProductInput = document.getElementById('ContactFormProduct');
    const ruckrufBlock = document.getElementById('ruckruf_block');
    const ruckrufBlockOverlay = document.getElementById('ruckruf_block_overlay');

    document.body.classList.remove('overflow-hidden')
    if (ruckrufBlock) {
        ruckrufBlock.classList.remove('right-0');
        ruckrufBlock.classList.add('-right-full', 'lg:-right-[500px]');
    }
    if (ruckrufBlockOverlay) {
        ruckrufBlockOverlay.classList.remove('left-0');
        ruckrufBlockOverlay.classList.add('-left-full');
    }
    if (contactFormProductInput) contactFormProductInput.value = '';
    if (ruckrufProductTitle) {
        ruckrufProductTitle.classList.add('hidden');
        ruckrufProductTitle.textContent = '';
    }
}

//////////////////////////////
// MATERIAL SAMPLE BLOCK
//////////////////////////////

function openMaterialSampleBlock(product_url) {
    const materialSampleBlock = document.getElementById('material_sample_block');
    const materialSampleBlockOverlay = document.getElementById('material_sample_block_overlay');
    const contactFormMaterialSampleInput = document.getElementById('ContactFormMaterialSample');

    document.body.classList.add('overflow-hidden')
    if (materialSampleBlock) {
        materialSampleBlock.classList.remove('-right-full', 'lg:-right-[500px]');
        materialSampleBlock.classList.add('right-0');
    }
    if (materialSampleBlockOverlay) {
        materialSampleBlockOverlay.classList.remove('-left-full');
        materialSampleBlockOverlay.classList.add('left-0');
    }
    if (contactFormMaterialSampleInput) contactFormMaterialSampleInput.value = product_url;
}

function closeMaterialSampleBlock() {
    const materialSampleBlock = document.getElementById('material_sample_block');
    const materialSampleBlockOverlay = document.getElementById('material_sample_block_overlay');
    const contactFormMaterialSampleInput = document.getElementById('ContactFormMaterialSample');

    document.body.classList.remove('overflow-hidden')
    if (materialSampleBlock) {
        materialSampleBlock.classList.remove('right-0');
        materialSampleBlock.classList.add('-right-full', 'lg:-right-[500px]');
    }
    if (materialSampleBlockOverlay) {
        materialSampleBlockOverlay.classList.remove('left-0');
        materialSampleBlockOverlay.classList.add('-left-full');
    }
    if (contactFormMaterialSampleInput) contactFormMaterialSampleInput.value = '';
}

//////////////////////////////
// LOGIN REGISTER BLOCK
//////////////////////////////
function openLoginRegisterBlock() {
    document.body.classList.add('overflow-hidden')
    const loginRegisterBlock = document.getElementById('login_register_block');
    const loginRegisterBlockOverlay = document.getElementById('login_register_block_overlay');

    if (loginRegisterBlock) {
        loginRegisterBlock.classList.remove('-right-full', 'lg:-right-[500px]');
        loginRegisterBlock.classList.add('right-0');
    }
    if (loginRegisterBlockOverlay) {
        loginRegisterBlockOverlay.classList.remove('-left-full');
        loginRegisterBlockOverlay.classList.add('left-0');
    }
}

function closeLoginRegisterBlock() {
    document.body.classList.remove('overflow-hidden')
    const loginRegisterBlock = document.getElementById('login_register_block');
    const loginRegisterBlockOverlay = document.getElementById('login_register_block_overlay');

    if (loginRegisterBlock) {
        loginRegisterBlock.classList.remove('right-0');
        loginRegisterBlock.classList.add('-right-full', 'lg:-right-[500px]');
    }
    if (loginRegisterBlockOverlay) {
        loginRegisterBlockOverlay.classList.remove('left-0');
        loginRegisterBlockOverlay.classList.add('-left-full');
    }
}

//////////////////////////////
// CART
//////////////////////////////

async function removeInsuranceProducts(updates, insurance_product_id) {
    console.log('removeInsuranceProducts');
    console.log(updates);

    try {
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({ updates })
        });

        const response = await fetch('/cart.js');
        const newCart = await response.json();
        if (newCart.items.some(item => item.product_id === insurance_product_id)) {
            window.location.href = '/cart';
        }
    } catch (error) {
        console.error('Error updating cart:', error);
    }
}

function checkOutLoading() {
    const cartBlockCheckoutText = document.getElementById('cart_block_checkout_text');
    const cartPageCheckoutText = document.getElementById('cart_page_checkout_text');
    const cartBlockCheckoutLoading = document.getElementById('cart_block_checkout_loading');
    const cartPageCheckoutLoading = document.getElementById('cart_page_checkout_loading');

    if (cartBlockCheckoutText) cartBlockCheckoutText.classList.add('hidden');
    if (cartPageCheckoutText) cartPageCheckoutText.classList.add('hidden');
    if (cartBlockCheckoutLoading) cartBlockCheckoutLoading.classList.remove('hidden');
    if (cartPageCheckoutLoading) cartPageCheckoutLoading.classList.remove('hidden');
}

async function removeProductWithRelations(selection) {
    if (window.confirm('Achtung! Dieser Vorgang führt zur Löschung aller Produkte von dieser Konfiguration.')) {
        let selected_items = {};
        document.querySelectorAll('.selection_' + selection).forEach(item => {
            if (item.textContent) {
                selected_items[item.textContent.trim()] = 0;
            }
        });

        try {
            await fetch(window.Shopify.routes.root + 'cart/update.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest'
                },
                body: JSON.stringify({ updates: selected_items })
            });
            window.location.href = '/cart';
        } catch (error) {
            console.error('Error updating cart:', error);
        }
    }
}

async function removeProduct(id) {
    try {
        const url = `/cart/change?line=${id}&quantity=0`;
        const response = await fetch(url, {
             method: 'POST',
             headers: {
                 'Content-Type': 'application/x-www-form-urlencoded',
                 'X-Requested-With': 'XMLHttpRequest'
             }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        window.location.href = '/cart';
    } catch (error) {
        console.error('Error removing product:', error);
    }
}

//////////////////////////////
// SEARCH SIDE BLOCK
//////////////////////////////
function openSearchSideBlock() {
    document.body.classList.add('overflow-hidden')
    const searchSideblock = document.getElementById('search_sideblock');
    const searchSideblockOverlay = document.getElementById('search_sideblock_overlay');

    if (searchSideblock) {
        searchSideblock.classList.remove('-right-full', 'lg:-right-[500px]');
        searchSideblock.classList.add('right-0');
    }
    if (searchSideblockOverlay) {
        searchSideblockOverlay.classList.remove('-left-full');
        searchSideblockOverlay.classList.add('left-0');
    }
}

function closeSearchSideBlock() {
    document.body.classList.remove('overflow-hidden')
    const searchSideblock = document.getElementById('search_sideblock');
    const searchSideblockOverlay = document.getElementById('search_sideblock_overlay');

    if (searchSideblock) {
        searchSideblock.classList.remove('right-0');
        searchSideblock.classList.add('-right-full', 'lg:-right-[500px]');
    }
    if (searchSideblockOverlay) {
        searchSideblockOverlay.classList.remove('left-0');
        searchSideblockOverlay.classList.add('-left-full');
    }
}

//////////////////////////////
// MOBILE NAVIGATION BLOCK
//////////////////////////////
function openMobileNavBlock() {
    document.body.classList.add('overflow-hidden')
    const mobilenavBlock = document.getElementById('mobilenav_block');
    const mobilenavBlockOverlay = document.getElementById('mobilenav_block_overlay');

    if (mobilenavBlock) {
        mobilenavBlock.classList.remove('-right-full');
        mobilenavBlock.classList.add('right-0');
    }
    if (mobilenavBlockOverlay) {
        mobilenavBlockOverlay.classList.remove('-left-full');
        mobilenavBlockOverlay.classList.add('left-0');
    }
}

function closeMobileNavBlock() {
    document.body.classList.remove('overflow-hidden')
    const mobilenavBlock = document.getElementById('mobilenav_block');
    const mobilenavBlockOverlay = document.getElementById('mobilenav_block_overlay');

    if (mobilenavBlock) {
        mobilenavBlock.classList.remove('right-0');
        mobilenavBlock.classList.add('-right-full');
    }
    if (mobilenavBlockOverlay) {
        mobilenavBlockOverlay.classList.remove('left-0');
        mobilenavBlockOverlay.classList.add('-left-full');
    }
}

function openVideoBox() {
    document.body.classList.add('overflow-hidden')
    const videoLightbox = document.getElementById('video_lightbox');
    if (videoLightbox) {
        videoLightbox.classList.remove('hidden');
        videoLightbox.classList.add('flex');
    }
}
function closeVideoBox() {
    document.body.classList.remove('overflow-hidden')
    const videoLightbox = document.getElementById('video_lightbox');
    if (videoLightbox) {
        videoLightbox.classList.remove('flex');
        videoLightbox.classList.add('hidden');
    }
}

// Back to top
function backToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

function updateFirstName() {
    const firstNameInput = document.getElementById("FirstName");
    const titleSelect = document.getElementById('CustomerTitle');
    const firstNameHiddenInputs = document.querySelectorAll('.first_name_register');
    const firstNameSidePanelInput = document.getElementById("FirstNameSidePanel");
    const titleSidePanelSelect = document.getElementById('CustomerTitleSidePanel');

    if (!firstNameInput || !titleSelect || !firstNameSidePanelInput || !titleSidePanelSelect) return;

    let firstName = firstNameInput.value;
    let titleOption = titleSelect.options[titleSelect.selectedIndex];
    let new_firstname = '';

    if (titleOption.value !== '0' && titleOption.value !== '3')  {
      new_firstname = titleOption.text + ' ' + firstName
      firstNameHiddenInputs.forEach(input => input.value = new_firstname)
    } else {
      new_firstname = firstName
      firstNameHiddenInputs.forEach(input => input.value = new_firstname)
    }

    firstNameSidePanelInput.value = firstName;
    titleSidePanelSelect.value = titleSelect.value;
}

function updateFirstNameSidePanel() {
    const firstNameSidePanelInput = document.getElementById("FirstNameSidePanel");
    const titleSidePanelSelect = document.getElementById('CustomerTitleSidePanel');
    const firstNameHiddenInputs = document.querySelectorAll('.first_name_register');
    const firstNameInput = document.getElementById("FirstName");
    const titleSelect = document.getElementById('CustomerTitle');

    if (!firstNameSidePanelInput || !titleSidePanelSelect || !firstNameInput || !titleSelect) return;

    let firstName = firstNameSidePanelInput.value;
    let titleOption = titleSidePanelSelect.options[titleSidePanelSelect.selectedIndex];
    let new_firstname = '';

    if (titleOption.value !== '0' && titleOption.value !== '3')  {
        new_firstname = titleOption.text + ' ' + firstName
        firstNameHiddenInputs.forEach(input => input.value = new_firstname)
    } else {
        new_firstname = firstName
        firstNameHiddenInputs.forEach(input => input.value = new_firstname)
    }

    firstNameInput.value = firstName;
    titleSelect.value = titleSidePanelSelect.value;
}

function updateFirstNameNewAddress() {
    const firstNameInput = document.getElementById("AddressFirstNameNew");
    const titleSelect = document.getElementById('CustomerTitleNewAddress');
    const firstNameHiddenInput = document.getElementById('FirstNameNewAddress');

    if (!firstNameInput || !titleSelect || !firstNameHiddenInput) return;

    let firstName = firstNameInput.value;
    let titleOption = titleSelect.options[titleSelect.selectedIndex];
    let new_firstname = '';

    if (titleOption.value !== '0' && titleOption.value !== '3')  {
      new_firstname = titleOption.text + ' ' + firstName
      firstNameHiddenInput.value = new_firstname
    } else {
      new_firstname = firstName
      firstNameHiddenInput.value = new_firstname
    }
}

function updateFirstNameAddresses(id) {
    const firstNameInput = document.getElementById('AddressFirstName_' + id);
    const titleSelect = document.getElementById('CustomerTitleNewAddress_' + id);
    const firstNameHiddenInput = document.getElementById('first_name_addresses_' + id);

    if (!firstNameInput || !titleSelect || !firstNameHiddenInput) return;

    let firstName = firstNameInput.value;
    let titleOption = titleSelect.options[titleSelect.selectedIndex];
    let new_firstname = '';

    if (titleOption.value !== '0' && titleOption.value !== '3')  {
      new_firstname = titleOption.text + ' ' + firstName
      firstNameHiddenInput.value = new_firstname
    } else {
      new_firstname = firstName
      firstNameHiddenInput.value = new_firstname
    }
}

async function addShippingDate() {
    let data = {attributes:{"Liefertermin":'xx.xx.xxxx'}}

    try {
        await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(data)
        });

        const cartPageFooter = document.getElementById('cart_page_footer');
        if (cartPageFooter) {
            cartPageFooter.classList.remove('hidden');
            cartPageFooter.classList.add('block');
        }
    } catch (error) {
        console.error('Error updating cart attributes:', error);
    }
}

function benefitsTextSlider() {
    const sliders = document.querySelectorAll("#mobile_header_gray .benefits-slider");
    if (!sliders.length) return;

    let currentSlideIndex = 0;
    const totalSlides = sliders.length;

    sliders.forEach((slider, index) => {
        if (index === currentSlideIndex) {
            slider.classList.remove('opacity-0', '-translate-y-full');
            slider.classList.add('opacity-1', 'translate-y-0');
        } else {
            slider.classList.remove('opacity-1', 'translate-y-0');
            slider.classList.add('opacity-0', '-translate-y-full');
        }
    });

    setInterval(() => {
        const currentSlider = sliders[currentSlideIndex];
        currentSlider.classList.remove('opacity-1', 'translate-y-0');
        currentSlider.classList.add('opacity-0', '-translate-y-full');

        currentSlideIndex = (currentSlideIndex + 1) % totalSlides;

        const nextSlider = sliders[currentSlideIndex];
        nextSlider.classList.remove('opacity-0', '-translate-y-full');
        nextSlider.classList.add('opacity-1', 'translate-y-0');

    }, 3000);
}

function updateTaggedButtonText() {
    document.querySelectorAll('.tagged-buy-button').forEach(button => {
        button.textContent = 'jetzt kaufen';
    });
}

if (document.querySelector('.my-element')) {
    updateTaggedButtonText();
} else {
    document.addEventListener('DOMContentLoaded', function() {
        const observer = new MutationObserver(function(mutations, obs) {
            let found = false;
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                         if (node.classList.contains('instafeed-lightbox')) {
                              found = true;
                         }
                         else if (node.querySelector('.instafeed-lightbox')) {
                              found = true;
                         }
                    }
                });
            });

             if (found) {
                updateTaggedButtonText();
                obs.disconnect();
            }
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
}
